const DEFAULT_LANGUAGE = 'en';
// @deprecated - will be removed when all usages are removed
const LANGUAGE_BCP47_MAP = {
  cs: 'cs',
  da: 'da',
  de: 'de',
  en: 'en',
  es: 'es',
  fi: 'fi',
  fr: 'fr',
  it: 'it',
  ja: 'ja',
  kk: 'kk',
  ko: 'ko',
  nb: 'nb',
  nl: 'nl',
  pl: 'pl',
  pt: 'pt',
  ru: 'ru',
  sv: 'sv',
  tr: 'tr',
  'zh-cn': 'zh-Hans',
  'zh-tw': 'zh-Hant',
};
const LANGUAGE_COUNTRY_MAP = {
  cs: 'cz',
  da: 'dk',
  de: 'de',
  en: 'en',
  es: 'es',
  fi: 'fi',
  fr: 'fr',
  it: 'it',
  ja: 'jp',
  kk: 'kk',
  ko: 'kr',
  nb: 'no',
  nl: 'nl',
  pl: 'pl',
  pt: 'br',
  ru: 'ru',
  sv: 'se',
  tr: 'tr',
  'zh-cn': 'cn',
  'zh-tw': 'tw',
};
// the storage key for the selected locale
const SELECTED_LOCALE_KEY = 'selectedLocale';
// BCP47 language codes as per https://wiki.corp.adobe.com/pages/viewpage.action?pageId=1387827668
// Only those languages whose value differs from their BCP47 language tag will have a bcp47Code property.
const SUPPORTED_LANGUAGES = [
  {
    dateFnsLocale: 'cs',
    label: 'Čeština',
    locale: 'cs_CZ',
    value: 'cs',
  },
  {
    dateFnsLocale: 'da',
    label: 'Dansk',
    locale: 'da_DK',
    value: 'da',
  },
  {
    dateFnsLocale: 'de',
    label: 'Deutsch',
    locale: 'de_DE',
    value: 'de',
  },
  {
    dateFnsLocale: 'en-US',
    label: 'English',
    locale: 'en_US',
    value: 'en',
  },
  {
    dateFnsLocale: 'es',
    label: 'Español',
    locale: 'es_ES',
    value: 'es',
  },
  {
    dateFnsLocale: 'fr',
    label: 'Français',
    locale: 'fr_FR',
    value: 'fr',
  },
  {
    dateFnsLocale: 'kk',
    // used for storing string ids for localization testing
    hidden: true, // only selectable via query param
    label: 'String ID',
    locale: 'kk_KZ',
    value: 'kk',
  },
  {
    dateFnsLocale: 'it',
    label: 'Italiano',
    locale: 'it_IT',
    value: 'it',
  },
  {
    dateFnsLocale: 'nl',
    label: 'Nederlands',
    locale: 'nl_NL',
    value: 'nl',
  },
  {
    dateFnsLocale: 'nb',
    label: 'Norsk',
    locale: 'nb_NO',
    value: 'nb',
  },
  {
    dateFnsLocale: 'pl',
    label: 'Polski',
    locale: 'pl_PL',
    value: 'pl',
  },
  {
    dateFnsLocale: 'pt',
    label: 'Português',
    locale: 'pt_BR',
    value: 'pt',
  },
  {
    dateFnsLocale: 'fi',
    label: 'Suomi',
    locale: 'fi_FI',
    value: 'fi',
  },
  {
    dateFnsLocale: 'sv',
    label: 'Svenska',
    locale: 'sv_SE',
    value: 'sv',
  },
  {
    dateFnsLocale: 'tr',
    label: 'Türkçe',
    locale: 'tr_TR',
    value: 'tr',
  },
  {
    dateFnsLocale: 'ru',
    label: 'Pусский',
    locale: 'ru_RU',
    value: 'ru',
  },
  {
    bcp47Code: 'zh-Hans',
    dateFnsLocale: 'zh-CN',
    label: '简体中文',
    locale: 'zh_CN',
    value: 'zh-cn',
  },
  {
    bcp47Code: 'zh-Hant',
    dateFnsLocale: 'zh-TW',
    label: '繁體中文',
    locale: 'zh_TW',
    value: 'zh-tw',
  },
  {
    dateFnsLocale: 'ja',
    label: '日本語',
    locale: 'ja_JP',
    value: 'ja',
  },
  {
    dateFnsLocale: 'ko',
    label: '한국어',
    locale: 'ko_KR',
    value: 'ko',
  },
];
const SURNAME_FIRST_LOCALES = ['ja', 'ko', 'zh-cn', 'zh-tw'];
const CHINESE_LANGUAGE_CODES = ['zh-cn', 'zh-tw'];

export {
  CHINESE_LANGUAGE_CODES,
  DEFAULT_LANGUAGE,
  LANGUAGE_BCP47_MAP,
  LANGUAGE_COUNTRY_MAP,
  SELECTED_LOCALE_KEY,
  SUPPORTED_LANGUAGES,
  SURNAME_FIRST_LOCALES,
};
